import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import { isDark } from '../../../global/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 'auto',
    backgroundColor: alpha(theme.colors.danger, 0.15),
    '@media print': {
      display: 'none',
    },
  },
  containerNone: {
    backgroundColor: isDark(theme) ? alpha(theme.colors.black, 0.15) : alpha(theme.colors.white, 0.15),
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    height: 74,
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
  formControlOverride: {
    marginRight: 0,
    marginLeft: 0,
  },
  checkbox: {
    marginLeft: -7,
    color: theme.palette.text.primary,
  },
  disabled: {
    color: alpha(theme.colors.grey, 0.5),
  },
}));

export default useStyles;
